<template>
  <div>
    <div v-if="value == 0">
      <img
        :src="require('@/assets/img/star_empty.png')"
        alt="star"
        class="img-fluid blaStepFieldBoxScoreStar d-inline-block"
      />
      <img
        :src="require('@/assets/img/star_empty.png')"
        alt="star"
        class="img-fluid blaStepFieldBoxScoreStar d-inline-block"
      />
      <img
        :src="require('@/assets/img/star_empty.png')"
        alt="star"
        class="img-fluid blaStepFieldBoxScoreStar d-inline-block"
      />
    </div>
    <div v-else-if="value == 1">
      <img
        :src="require('@/assets/img/star.png')"
        alt="star"
        class="img-fluid blaStepFieldBoxScoreStar d-inline-block"
      />
      <img
        :src="require('@/assets/img/star_empty.png')"
        alt="star"
        class="img-fluid blaStepFieldBoxScoreStar d-inline-block"
      />
      <img
        :src="require('@/assets/img/star_empty.png')"
        alt="star"
        class="img-fluid blaStepFieldBoxScoreStar d-inline-block"
      />
    </div>
    <div v-else-if="value == 2">
      <img
        :src="require('@/assets/img/star.png')"
        alt="star"
        class="img-fluid blaStepFieldBoxScoreStar d-inline-block"
      />
      <img
        :src="require('@/assets/img/star.png')"
        alt="star"
        class="img-fluid blaStepFieldBoxScoreStar d-inline-block"
      />
      <img
        :src="require('@/assets/img/star_empty.png')"
        alt="star"
        class="img-fluid blaStepFieldBoxScoreStar d-inline-block"
      />
    </div>
    <div v-else>
      <img
        :src="require('@/assets/img/star.png')"
        alt="star"
        class="img-fluid blaStepFieldBoxScoreStar d-inline-block"
      />
      <img
        :src="require('@/assets/img/star.png')"
        alt="star"
        class="img-fluid blaStepFieldBoxScoreStar d-inline-block"
      />
      <img
        :src="require('@/assets/img/star.png')"
        alt="star"
        class="img-fluid blaStepFieldBoxScoreStar d-inline-block"
      />
    </div>
  </div>
</template>

<script>
export default {
  props: {
    value: Number,
  },
};
</script>
